import { render, staticRenderFns } from "./LanguageFlag.vue?vue&type=template&id=aafea198&"
import script from "./LanguageFlag.vue?vue&type=script&lang=ts&"
export * from "./LanguageFlag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports